import axios from "axios";

// axios.defaults.baseURL = "http://localhost:3001";
axios.defaults.baseURL = "https://rickandmorty-back-mu1jqnrjn-sanbran.vercel.app/"

export default axios;
